
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import OxygenControl from "@/oxygen/classes/OxygenControl.vue";

import { Control } from "@/oxygen/classes/lib/types";
import defensiveCopy from "@/util/defensive-copy";
import { showControl } from "@/oxygen/classes/lib/conditions";

@Component({
  components: { OxygenControl }
})
export default class OxygenControls extends Vue {
  @Prop({
    default: () => []
  })
  controls!: Control[];

  @Prop({
    default: false
  })
  root!: boolean;

  @Prop()
  path!: string;

  @ModelSync("value", "input")
  syncedValue?: Record<string, unknown>;

  get filteredControls() {
    return this.controls.filter(control =>
      showControl(control.conditions, this.syncedValue)
    );
  }

  updateControlValue(control: Control, value: unknown) {
    const newValue = defensiveCopy(this.syncedValue);

    this.$emit("input", {
      ...newValue,
      [control.slug]: value
    });
  }

  updateContext(context: Record<string, unknown>) {
    this.$emit("input", context);
  }
}
